export default __webpack_public_path__ + "static/media/blue_bird.7f67601a.png";